import { render, staticRenderFns } from "./FiveStarClassPublishList.vue?vue&type=template&id=369f754a&scoped=true"
import script from "./FiveStarClassPublishList.vue?vue&type=script&lang=js"
export * from "./FiveStarClassPublishList.vue?vue&type=script&lang=js"
import style0 from "./FiveStarClassPublishList.vue?vue&type=style&index=0&id=369f754a&prod&scoped=true&lang=css"
import style1 from "./FiveStarClassPublishList.vue?vue&type=style&index=1&id=369f754a&prod&lang=css"
import style2 from "./FiveStarClassPublishList.vue?vue&type=style&index=2&id=369f754a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f754a",
  null
  
)

export default component.exports